module.exports = __webpack_public_path__ + "static/media/widgetPopup.63a2343e.svg";